import { IUser } from "../Types/user";

export const getUserFromLS = () => {
    const userJson = localStorage.getItem('user') || '{}';
    return JSON.parse(userJson) as IUser;
}
